import { Link, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { ThreadDetail } from '@/features/wizard-magic-email';

/** One advisor's Magic Email conversation on its own page. `/wizard/magic-email/threads/:advisorId/:threadKey`. */
export function WizardMagicEmailThreadPage() {
  const { advisorId, threadKey } = useParams<{ advisorId: string; threadKey: string }>();

  return (
    <main className="min-h-full bg-[#F7F7F8] px-4 pt-5 pb-12 sm:px-6 lg:px-10">
      <div className="mx-auto flex max-w-[1320px] flex-col gap-4">
        <Link to="/wizard/magic-email?tab=conversations" className="inline-flex min-h-11 items-center gap-1.5 self-start text-sm font-medium text-zinc-600">
          <ChevronLeft className="size-4" aria-hidden /> All conversations
        </Link>
        {advisorId && threadKey ? <ThreadDetail advisorId={advisorId} threadKey={threadKey} live /> : null}
      </div>
    </main>
  );
}
